function DateConverter(props){
    const date = new Date(Number(props.data));
    date.setHours(date.getHours()+1);

    return <>
        <span>{props.startmessage}{date.getFullYear()}年{date.getMonth()+1}月{date.getDate()}日{date.getHours()+1}時{date.getMinutes()}分{props.endmessage}</span>
    </>
}

export default DateConverter